import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Network from "../../../config/network";
import Configuration from "src/config/configuration";
import { getParametersHeaderPost } from "src/config/helper";

export const getAllUsers = createAsyncThunk(
  "getAllUsers",
  async (tenantName: string) => {
    try {
      const response = await Network.get(
        Configuration.apis.getAllUsers,
        getParametersHeaderPost({ tenantId: tenantName }),
      );
      if (response.status) {
        const resultData = response.data;
        return resultData;
      }
    } catch (err) {
      console.log(err);
    }
  },
);

interface getAllUsersState {
  getAllUsersDetails: any;
  loading: boolean;
  error: any;
}

const getAllUsersInitialState: getAllUsersState = {
  getAllUsersDetails: {},
  loading: false,
  error: {},
} satisfies getAllUsersState as getAllUsersState;

const getAllUsersSlice = createSlice({
  name: "getAllUsers",
  initialState: getAllUsersInitialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.error = "";
        state.getAllUsersDetails = action.payload;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.getAllUsersDetails = {};
      });
  },
});

export default getAllUsersSlice.reducer;
